<template>
    <web-modal id="onboarding-welcome" is-active>
        <template slot="content">
            <figure>
                <img
                    src="imgs/web/modal_onboarding_de.webp"
                    srcset="imgs/web/modal_onboarding_de.webp 1x, imgs/web/modal_onboarding_de@2x.webp 2x"
                    alt=""
                >
            </figure>

            <strong class="new-headline-lg text-centered">Mehr Energie.<br>Bessere Blutzuckerwerte.<br>Gesünderes Gewicht.</strong>

            <p class="new-text-lg text-centered">Ihr persönlicher Begleiter bei Typ-2-Diabetes.</p>

            <v-button
                modal-target="dismiss"
                size="lg"
                position="center"
                label="Los geht’s!"
            ></v-button>
        </template>
    </web-modal>
</template>

<script>
    export default {}
</script>
